const STEPS = [
  { key: "clicks", label: "CLICKS" },
  { key: "unique_visitors", label: "UNIQUE" },
  { key: "verified_discord", label: "DISCORD VERIFY" },
  { key: "discord_joins", label: "EVER JOINED" },
  { key: "current_members", label: "CURRENT" },
  { key: "left_members", label: "LEFT" },
];

export default function FunnelBars({ data }) {
  const max = Math.max(1, ...STEPS.map((s) => data[s.key] || 0));
  return (
    <div className="space-y-2">
      {STEPS.map((s, i) => {
        const v = data[s.key] || 0;
        const pct = Math.max(4, (v / max) * 100);
        const isLeft = s.key === "left_members";
        const isCurrent = s.key === "current_members";
        const color = isLeft ? "#FF3B30" : isCurrent ? "#E4FF00" : "#00F0FF";
        return (
          <div key={s.key} className="flex items-center gap-3">
            <div className="kbd-label w-32 shrink-0">{s.label}</div>
            <div className="flex-1 h-6 bg-white/5 relative">
              <div
                className="h-full transition-[width] duration-500"
                style={{ width: `${pct}%`, background: color, boxShadow: `inset 0 0 12px ${color}66` }}
              />
              <span className="absolute inset-0 flex items-center px-2 stat-value text-xs text-black mix-blend-difference">{v}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
